import { useCallback, useEffect, useState } from 'react'
import { useDocument } from './use.document'
import { usePermission } from './use.permission'
import { useStorage } from './use.storage'

const KEY = 'staff-snippet-hint'

export const useSnippetHint = () => {
  const { isStaff } = usePermission()
  const document = useDocument()
  const [showHint, setShowHint] = useState(false)

  const { local } = useStorage(({ local }) => {
    setShowHint(Boolean(local.getItem(KEY)))
  })

  useEffect(() => {
    if (!document || !local) {
      return
    }

    const listener = () => {
      setShowHint(Boolean(local.getItem(KEY)))
    }

    document.addEventListener(KEY, listener)

    return () => document.removeEventListener(KEY, listener)
  }, [local, document])

  const toggle = useCallback(() => {
    if (!document || !local) {
      return
    }

    setShowHint(prev => {
      if (prev) {
        local.removeItem(KEY)
      } else {
        local.setItem(KEY, '1')
      }

      document.dispatchEvent(new Event(KEY))

      return !prev
    })
  }, [local, document])

  return {
    toggle,
    visible: showHint && isStaff,
  }
}
